export default function CustomMarker({ map, position, data }) {
  //console.log('CustomMarker', position)
  // this.setMap(map);

  this.position = position;
  this.data = data;

  // this.markerEl = document.createElement('div');
  // this.markerEl.className = 'marker';
  // this.markerEl.style.position = 'absolute';
  // this.markerEl.style.cursor = 'pointer';
  // this.markerEl.style.width = '2px';
  // this.markerEl.style.height = '2px';
  // this.markerEl.style.background = 'transparent';

  // google.maps.event.addDomListener(this.markerEl, "click", (event) => {
  //   console.log('customMarker', 'click')
  //   google.maps.event.trigger(this, "click");
  // });

}
  /* CustomMarker extends OverlayView in the Google Maps API v3. */
  //CustomMarker.prototype = new google.maps.OverlayView();
  //
  // CustomMarker.prototype.draw = function () {
  //   console.log('customMarker', 'draw')
  //   const panes = this.getPanes();
  //   panes.overlayImage.appendChild(this.markerEl);
  //
  //   const point = this.getProjection().fromLatLngToDivPixel(this.position);
  //   if (point) {
  //     this.markerEl.style.left = point.x + 'px';
  //     this.markerEl.style.top = point.y + 'px';
  //   }
  // };
  //
  // CustomMarker.prototype.remove = function () {
  //   if (this.markerEl) {
  //     this.markerEl.parentNode.removeChild(this.markerEl);
  //     this.markerEl = null;
  //   }
  // };

  CustomMarker.prototype.getPosition = function () {
    return this.position;
  };

// CustomMarker.prototype.setContent = function (html) {
//   console.log('customMarker', 'setContent')
//   // If map pin is currently in view.
//   if (this.markerEl) {
//     this.markerEl.innerHTML = html;
//   }
// };
//
// CustomMarker.prototype.setActive = function () {
//   console.log('customMarker', 'setActive')
//   if (this.markerEl) {
//     this.markerEl.classList.add('active');
//   }
// };
//
// CustomMarker.prototype.setInactive = function () {
//   console.log('customMarker', 'setInactive')
//   if (this.markerEl) {
//     this.markerEl.classList.remove('active');
//   }
// };
